/** Manages title editing and navigation restoration after saving in the task list. */
import { useCallback } from 'react';

export const useTaskListEditActions = ({
  user,
  updateTask,
  editingTaskId,
  onStopEditing,
  selectSingleTask,
  taskListRef,
}) => {
  const handleStopEditingAndRestoreSelection = useCallback(
    (shouldRestoreFocus) => {
      onStopEditing();
      if (shouldRestoreFocus && editingTaskId) {
        setTimeout(() => {
          selectSingleTask(editingTaskId);
          if (taskListRef.current) {
            const taskItem = taskListRef.current.querySelector(
              `[data-task-id="${editingTaskId}"]`,
            );
            if (taskItem) taskItem.focus();
          }
        }, 0);
      }
    },
    [onStopEditing, selectSingleTask, editingTaskId, taskListRef],
  );

  const handleSave = useCallback(
    async (newTitle) => {
      if (editingTaskId) {
        await updateTask(editingTaskId, { title: newTitle }, user.uid);
        handleStopEditingAndRestoreSelection(true);
      }
    },
    [editingTaskId, updateTask, user, handleStopEditingAndRestoreSelection],
  );

  return { handleSave, handleStopEditingAndRestoreSelection };
};
